<script>
  import { onDestroy } from "svelte";
  import { tooltip, Tooltip } from "@svelte-plugins/tooltips";
  import {
    radioCheck,
    isCalculate,
    totalPopulation,
    averageAge,
    LoadingBarValue,
    InsightsRadioCheck,
    topZonesStore,
    DistanceFromZonesSP,
    ParkingDensitySP,
  } from "../../../store.js";

  $: $ParkingDensitySP = parkingDensity;
  $: $DistanceFromZonesSP = zones;
  import CalculateSchemePotential from "./CalculateSchemePotential.svelte";

  let expanded = false;
  let zones = 2;
  let parkingDensity = 100;
  let topZones = 10;
  let walkTime = 15;

  export let map;
</script>

<div class="schemePotential">
  <h4 style="color:white;margin:15px;font-weight:500">Scheme potential:</h4>
  <CalculateSchemePotential {zones} {map} />
  <div
    class="slidecontainer"
    style="position:relative;left: 18px;font-size:12px;top:20px"
  >
    <p>
      <span
        use:tooltip={{
          content:
            "<span style='font-size:11px'> Please choose the average journey length you would like to allow for in your local area</span>",
          position: "top",
          autoPosition: true,
          style: {
            backgroundColor: "gray",
          },
          maxWidth: 175,
        }}
        style="position: relative;
      z-index: 100000"
      >
        Select travel zone size
      </span><span
        style="text-align: justify;
  right: 25px;
  top: -7px;
  font-weight: 600;
  font-size: 22px;
  color: #45bcbb;
  position: absolute;"
        >{zones}
        <span style="font-weight: 400;font-size:16px">km</span></span
      >
    </p>
    <input
      id="topZones"
      style="margin-top: -10px;width:80%;padding:0px;accent-color:#45bcbb"
      type="range"
      step=".5"
      min="2"
      max="10"
      bind:value={zones}
    />
  </div>
  <div
    class="slidecontainer"
    style="position:relative;left: 18px;font-size:12px;top:10px"
  >
    <p>
      <span
        use:tooltip={{
          content:
            "<span style='font-size:11px'>Please choose the density of parking bays that are likely to be needed in your local area</span>",
          position: "top",
          autoPosition: true,
          style: {
            backgroundColor: "gray",
          },
          maxWidth: 175,
        }}
        style="position: relative;
    z-index: 100000"
      >
        Select parking bay density:</span
      ><span
        style="    text-align: justify;
  right: 20px;
  top: -7px;
  font-weight: 600;
  font-size: 22px;
  color: #45bcbb;
  position: absolute;"
        >{parkingDensity}<span style="font-weight: 400;font-size:16px">m</span
        ></span
      >
    </p>

    <input
      style="margin-top: -10px;width:80%;padding:0px;accent-color:#45bcbb"
      type="range"
      step="100"
      min="100"
      max="500"
      bind:value={parkingDensity}
    />
  </div>
</div>

<style>
</style>
